var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";
import Checkbox from "../checkbox";

var Radio = function Radio(props) {
  return React.createElement(Checkbox, _extends({ type: "radio" }, props));
};

export default Radio;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/radio/radio.js
// module id = null
// module chunks = 